import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useNotification } from 'components/notification/Notification';
import { useI18n } from 'hooks/usei18n';
import { ROUTES } from 'routes/routes';
import { logout } from 'utils/auth';
import { onApiEvent } from 'utils/apiEvents';

/** Shows the messages for failed API calls and sends visitors with an expired session back to the login page (which says why). */
const ApiErrorNotifier = () => {
  const { t } = useTranslation();
  const { showNotification } = useNotification();
  const { getLanguageUrl } = useI18n();
  const location = useLocation();

  useEffect(() => {
    const unsubscribers = [
      onApiEvent('sessionExpired', () => {
        logout();
        // A full page load, not a client-side navigation: App switches hooks on/off with the login state,
        // so it must start again from the logged-out state. The login page shows the message.
        window.location.assign(`${getLanguageUrl(ROUTES.Login.path)}?returnTo=${encodeURIComponent(location.pathname + location.search)}&reason=expired`);
      }),
      onApiEvent('tooManyRequests', () => {
        showNotification(t('errors.tooManyRequests'));
      }),
      onApiEvent('offline', () => {
        showNotification(t('errors.offline'));
      })
    ];

    return () => {
      unsubscribers.forEach((unsubscribe) => {
        unsubscribe();
      });
    };
  }, [t, showNotification, getLanguageUrl, location.pathname, location.search]);

  return null;
};

export default ApiErrorNotifier;
